import './App.css';
import { useState, useEffect } from 'react';
import axios from 'axios';

const EditIcon = () => <span className="icon edit-icon">✏️</span>; 
const DeleteIcon = () => <span className="icon delete-icon">🗑️</span>; 

const API_URL = process.env.REACT_APP_API_URL;
function App() {
  const [tasks, setTasks] = useState([]);
  const [newTaskText, setNewTaskText] = useState('');
  const [filter, setFilter] = useState('all'); 
  const [editTaskId, setEditTaskId] = useState(null); 
  const [editTaskText, setEditTaskText] = useState(''); 

  useEffect(() => {
    const getTasks = async () => {
      try {
        const res = await axios.get(API_URL + '/tasks');
        setTasks(res.data);
      } catch (error) {
        console.error('Error fetching tasks:', error);
      }
    };
    getTasks();
  }, []);

  const handleCreateTask = async (e) => {
    e.preventDefault();
    if (!newTaskText.trim()) return; 

    try {
      const res = await axios.post(API_URL + '/tasks', {
        text: newTaskText,
      });
      setTasks([res.data, ...tasks]);
      setNewTaskText('');
    } catch (error) {
      console.error('Error creating task:', error);
    }
  };

  const handleDeleteTask = async (idToDelete) => {
    try {
      await axios.delete(API_URL + '/tasks/' + idToDelete);
      setTasks(tasks.filter(task => task._id !== idToDelete));
    } catch (error) {
      console.error('Error deleting task:', error);
    }
  };

  const handleToggleComplete = async (idToUpdate) => {
    try {
      const res = await axios.put(API_URL + '/tasks/' + idToUpdate);
      setTasks(tasks.map(task =>
        task._id === idToUpdate ? res.data : task
      ));
    } catch (error) {
      console.error('Error updating task:', error);
    }
  };

  const handleStartEdit = (task) => {
    setEditTaskId(task._id);
    setEditTaskText(task.text);
  };

  const handleCancelEdit = () => {
    setEditTaskId(null);
    setEditTaskText('');
  };

  const handleSaveEdit = async (idToUpdate) => {
    if (!editTaskText.trim()) return; 

    try {
      const res = await axios.put(API_URL + '/tasks/' + idToUpdate, { text: editTaskText });

      setTasks(tasks.map(task =>
        task._id === idToUpdate ? res.data : task
      ));
      setEditTaskId(null);
      setEditTaskText('');
    } catch (error) {
      console.error('Error saving edit:', error);
    }
  };


  const filteredTasks = tasks.filter(task => {
    if (filter === 'completed') return task.isCompleted;
    if (filter === 'pending') return !task.isCompleted;
    return true; 
  });

  const totalTasks = tasks.length;
  const completedTasks = tasks.filter(task => task.isCompleted).length;
  const pendingTasks = tasks.filter(task => !task.isCompleted).length;

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'numeric', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };


  return (
    <div className="App">
     
      <header className="app-header">
        <h1>Todo List</h1>
        <p>Stay organized and get things done!</p>
      </header>

    
      <div className="summary-cards">
        <div className="card total">
          <h3>{totalTasks}</h3>
          <p>Total Tasks</p>
        </div>
        <div className="card completed">
          <h3>{completedTasks}</h3>
          <p>Completed</p>
        </div>
        <div className="card pending">
          <h3>{pendingTasks}</h3>
          <p>Pending</p>
        </div>
      </div>

    
      <div className="action-bar">
        <button className="add-new-task-btn">+ Add New Task</button> {/* This will open the form */}
        <div className="filters">
          <button 
            className={`filter-btn ${filter === 'all' ? 'active' : ''}`}
            onClick={() => setFilter('all')}
          >
            All
          </button>
          <button 
            className={`filter-btn ${filter === 'pending' ? 'active' : ''}`}
            onClick={() => setFilter('pending')}
          >
            Pending
          </button>
          <button 
            className={`filter-btn ${filter === 'completed' ? 'active' : ''}`}
            onClick={() => setFilter('completed')}
          >
            Completed
          </button>
        </div>
      </div>

     
      <form onSubmit={handleCreateTask} className="task-form">
        <input
          type="text"
          placeholder="Add a new task..."
          value={newTaskText}
          onChange={(e) => setNewTaskText(e.target.value)}
        />
        <button type="submit">Add Task</button>
      </form>

      
      <div className="task-list">
        {filteredTasks.map(task => (
          <div
            key={task._id}
            className={`task-item ${task.isCompleted ? 'completed' : ''}`}
          >
            {editTaskId === task._id ? ( 
              <div className="edit-mode">
                <input
                  type="text"
                  value={editTaskText}
                  onChange={(e) => setEditTaskText(e.target.value)}
                  onKeyPress={(e) => { 
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      handleSaveEdit(task._id);
                    }
                  }}
                />
                <button className="save-edit-btn" onClick={() => handleSaveEdit(task._id)}>Save</button>
                <button className="cancel-edit-btn" onClick={handleCancelEdit}>Cancel</button>
              </div>
            ) : ( 
              <>
                <div className="task-content">
                  <input
                    type="checkbox"
                    checked={task.isCompleted}
                    onChange={() => handleToggleComplete(task._id)}
                  />
                  <div>
                    <p className="task-text">{task.text}</p>
                    <div className="task-dates">
                        <span className="created-date">Created: {formatDate(task.createdAt)}</span>
                        {task.updatedAt && task.createdAt !== task.updatedAt && (
                            <span className="updated-date"> • Updated: {formatDate(task.updatedAt)}</span>
                        )}
                    </div>
                  </div>
                </div>
                <div className="task-actions">
                  <span className="action-icon" onClick={() => handleStartEdit(task)}><EditIcon /></span>
                  <span className="action-icon" onClick={() => handleDeleteTask(task._id)}><DeleteIcon /></span>
                </div>
              </>
            )}
          </div>
        ))}
        {filteredTasks.length === 0 && (
          <p className="no-tasks-message">No tasks found for this filter.</p>
        )}
      </div>
    </div>
  );
}

export default App;